module.exports = __webpack_public_path__ + "static/media/grupo-biotoscana.63ea191a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/grupo-biotoscana.png
// module id = 122
// module chunks = 0